import React from 'react';
import { Accordion } from './Accordion';
const faqs = [{
  q: '¿Es para cualquier nivel de jugador?',
  a: 'Sí, el sistema está diseñado para adaptarse. Ya seas amateur o juegues torneos de club, los ejercicios tienen progresiones para que los ajustes a tu nivel actual.'
}, {
  q: '¿Necesito ir al gimnasio?',
  a: 'No es estrictamente necesario. Muchos ejercicios se pueden hacer con peso corporal o bandas elásticas en tu casa o antes de entrar a la cancha.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'El acceso es inmediato. Apenas se confirma el pago, recibís un mail con todos los PDFs y planillas de Excel listos para descargar y usar en tu celular o computadora.'
}, {
  q: '¿Qué pasa si no tengo tiempo?',
  a: 'El planificador semanal está pensado para gente ocupada. Podés integrar las rutinas en solo 20-30 minutos al día o sumarlas a tus días de tenis.'
}];
export function FAQ() {
  return <div className="py-8" data-id="element-98">
      <h3 className="text-2xl font-black text-center text-white mb-6 uppercase italic" data-id="element-99">
        Preguntas Frecuentes
      </h3>
      <div className="flex flex-col gap-2" data-id="element-100">
        {faqs.map((faq, i) => <Accordion key={i} title={faq.q} content={faq.a} data-id="element-101" />)}
      </div>
    </div>;
}